export const spacing = {
  spacing_xxs: 4,
  spacing_xs: 8,
  spacing_sm: 12,
  spacing_md: 16,
  spacing_lg: 32,
  spacing_xl: 64,
  spacing_xxl: 128,
}
